export default __webpack_public_path__ + "static/media/Background_00260.0a445d06.png";